 <style lang="scss" scoped>
.directory {
	&__container {
		@include container;
	}
	&__panel {
		@include main-panel;
	}
	&__warning-text {
		color: #d7553d;
		font-weight: 600;
	}
	&__done {
		text-align: center;
		padding-top: 100px;
		padding-bottom: 100px;
		&__message {
			margin-top: 20px;
			font-weight: 600;
			font-size: 23px;
			color: #393942;
		}
		&__emoji {
			img {
				width: 150px;
				margin: auto;
			}
		}
	}
	&__header {
		@include flex-center;
		&__buttons {
			margin-left: auto;
			> div {
				margin-left: 15px;
			}
		}
	}
	&__select {
		width: 100%;
	}
	&__table {
		td,
		th {
			&:first-child {
				padding-left: 40px;
			}
			&:last-child {
				padding-right: 40px;
			}
		}
		td.-item {
			cursor: pointer;
		}
		&__missing-item {
			display: inline-block;
			padding-left: 10px;
			color: red;
			font-size: 16px;
			vertical-align: middle;
		}
	}
	&__footer {
		@include main-panel-footer;
		&__right {
			margin-left: auto;
		}
	}
	& /deep/ .el-select {
		width: 100%;
	}

	&__manual-assign {
		height: 58px;
		margin: 0 0 0;
		padding-bottom: 5px;
		&__row {
			div:first-of-type {
				margin-top: 2px;
			}
			div:last-of-type {
				margin-top: -15px;
				font-weight: lighter;
			}
		}
	}
}
</style>
<template lang="pug">
div.directory
	app-header
		.directory__header(slot='header')
			h1.directory__header__title User directory
			.directory__header__buttons
				auto-enable-button(v-if="features.sync")
				el-button(v-if="features.sync" type='warning', icon='fe fe-repeat fe-just-off', @click="goToSync", e2e="directory-run-sync") Calculate MIS sync summary
				el-tooltip.item(effect='dark', :disabled='!!selected.length', content='Please select at least one user first', placement='bottom')
					el-dropdown(@command='multiSelectCommand')
						el-button(type='primary', :disabled='!selected.length', :loading='commandRunning')
							template(v-if='selected.length')
								| {{ commandRunning ? "Actioning" : "Action "}} {{selected.length}} selected
							template(v-else='')
								| Action selected
							i.el-icon-arrow-down.el-icon--right
						el-dropdown-menu(slot='dropdown')
							el-dropdown-item(v-if="features.sync" command='create') Create {{ providerName }} user{{ selected.length == 1 ? '' : 's' }}
							el-dropdown-item(v-if="features.sync" command='skip') Ignore
							el-dropdown-item(v-if="features.sync" command='activate', divided='') Unsuspend {{ providerName }} user{{ selected.length == 1 ? '' : 's' }}
							el-dropdown-item(command='unmatch') Unmatch {{ providerName }} user
							el-dropdown-item(v-if="features.sync" command='passwords', divided='') Download password{{ selected.length > 1 ? "s" : "" }}
							el-dropdown-item(v-if="features.sync" command='suspend', divided='') Suspend {{ providerName }} user{{ selected.length == 1 ? '' : 's' }}
							el-dropdown-item(v-if="features.sync" command='remove')
								.directory__warning-text Delete {{ providerName }} user{{ selected.length == 1 ? '' : 's' }}
	.directory__container
		.directory__panel
			stats-bar(v-if='directory && directory.WondeUsers', :results='directory.WondeUsers')
			result-filter.ml-auto.mr-2(v-model='filters', :filter-fields='fields', :remember="true")
			loading(v-if='directoryLoading')
			loading(v-else-if='commandRunning', :message="['Loading...','Doing clever things...', 'Moving things around...', 'Just one moment...']")
			template(v-else-if="showUnmatchedSuccessMessage")
				.directory__done
					.directory__done__emoji
						img(src="/emoji/celebration.png")
					.directory__done__message Great news, all users matched!
			empty(v-else-if='!paginated.length', :message="!directory.WondeUsers.length ? 'No users available, please check settings' : 'No users matching search criteria'")
			template(v-else)
				table.table.directory__table
					thead
						tr
							th
								input(v-model='checkAll', type='checkbox')
							th First name
							th Last name
							th Date of Birth
							th Type
							th(width='140') State
							th(width='300') Assigned to
							th Options
					tbody
						tr(v-for='(row, index) in paginated', @click='row.selected = !row.selected', :key='index')
							td
								input(v-model='row.selected', type='checkbox')
							td {{ row.first_name }}
							td {{ row.last_name }}
							td {{ row.date_of_birth | date_convert }}
							td {{ row.base_type | capitalize }}
							td
								el-badge(:hidden="!row.missing" is-dot)
									el-tooltip(:disabled="!row.missing" placement="auto")
										div(slot="content") 
											| This person in no longer found in your MIS data
											br 
											| Unmatch them to prevent potential suspension or deletion
										el-tag(type='success', size='medium', v-if="row.status && ['matched', 'created'].includes(row.status)") matched
										el-tag(type='info', size='medium', v-else-if="row.status && row.status == 'skipped'") ignored
										el-tag(type='danger', size='medium', v-else-if="row.status && row.status == 'suspended'") suspended
										el-tag(size='medium', v-else='') unmatched
							td(v-loading='row.assigning')
								template(v-if="row.status && ['matched', 'created', 'deleted', 'suspended'].includes(row.status)") {{ row.matched_name }}
								template(v-else-if='row.assign == true')
									el-select.w-100(ref='assignSelect', filterable='', v-model='row.match', @change='assignChange', size='medium', value-key='id', :loading='matchingLoading')
										el-option.directory__manual-assign(v-for='row in matching.ThirdPartyUsers', :key='row.id', :label="row.first_name + ' ' + row.last_name + ' ' + row.email", :value='row')
											.directory__manual-assign__row
												div {{ row.first_name }} {{ row.last_name }} 
												div {{ row.email }}
								template(v-else='') Nobody
							td(width='120')
								el-button(type='text', :disabled="saveLoading || (row.status && ['created', 'matched'].includes(row.status))", @click.stop='assign(row)', size='medium', :loading='row.assign && matchingLoading') Manually assign
				.directory__footer
					.directory__footer__left
						el-pagination(background='', layout='prev, pager, next', :current-page.sync='page', :page-size='per_page', :total='filtered.length')
					.directory__footer__right                        
						| Showing
						strong &nbsp;{{ paginated.length }}
						| &nbsp;out of a possible
						strong &nbsp;{{ filtered.length }}
						| &nbsp;results

</template>
<script>
import AutoEnableButton from "./../includes/AutoEnableButton";
import StatsBar from "./../includes/StatsBar";
import gql from "graphql-tag";
import _ from "lodash";
import csv from "@/libs/csv";

export default {
	components: {
		AutoEnableButton,
		StatsBar
	},

	watch: {
		checkAll() {
			if (this.checkAll) {
				_.each(this.paginated, r => {
					r.selected = true;
				});
			} else {
				_.each(this.paginated, r => {
					r.selected = false;
				});
			}
		}
	},

	data() {
		return {
			commandRunning: false,
			checkAll: false,
			filters: null,
			page: 1,
			per_page: 50,
			directory: {},
			matching: {},
			directoryLoading: true,
			matchingLoading: true,
			saveLoading: false,
			fields: [
				{
					name: "First name",
					path: "first_name",
					type: "text"
				},
				{
					name: "Last name",
					path: "last_name",
					type: "text"
				},

				{
					name: "Email",
					path: "email",
					type: "text"
				},
				{
					name: "State",
					path: "state",
					type: "radio",
					options: [
						{
							label: "Matched",
							value: "matched"
						},
						{
							label: "Unmatched",
							value: "unmatched"
						},
						{
							label: "Ignored",
							value: "skipped"
						},
						{
							label: "Suspended",
							value: "suspended"
						}
					],
					value: "unmatched"
				},
				{
					name: "User type",
					path: "base_type",
					type: "radio",
					options: [
						{
							label: "Employees",
							value: "employee"
						},

						{
							label: "Students",
							value: "student"
						}
					]
				}
			]
		};
	},

	computed: {
		showUnmatchedSuccessMessage() {
			if (this.filters && this.filters.state && this.filters.state === "unmatched") {
				// If there is only one filter active
				if (_.size(this.filters) === 1) {
					return !this.paginated.length;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		selected() {
			return _.filter(this.paginated, { selected: true });
		},
		filtered() {
			if (this.directory && this.directory.WondeUsers) {
				let users = this.directory.WondeUsers;
				if (!_.isEmpty(this.filters)) {
					if (this.filters.first_name) {
						users = _.filter(users, user => (user.first_name ? _.startsWith(user.first_name.toLowerCase(), this.filters.first_name.toLowerCase()) : false));
					}
					if (this.filters.last_name) {
						users = _.filter(users, user => (user.last_name ? _.startsWith(user.last_name.toLowerCase(), this.filters.last_name.toLowerCase()) : false));
					}
					if (this.filters.state) {
						if (this.filters.state === "matched") {
							users = _.filter(users, user => ["created", "matched"].includes(user.status));
						} else {
							users = _.filter(users, user => (user.status ? user.status == this.filters.state : false));
						}
					}
					if (this.filters.email) {
						users = _.filter(users, user => (user.matched_name ? _.startsWith(user.matched_name.toLowerCase(), this.filters.email.toLowerCase()) : false));
					}
					if (this.filters.base_type) {
						users = _.filter(users, { base_type: this.filters.base_type });
					}
				}
				return _.sortBy(users, ["last_name", "first_name"]);
			} else {
				return [];
			}
		},
		paginated() {
			return _.slice(this.filtered, (this.page - 1) * this.per_page, (this.page - 1) * this.per_page + this.per_page);
		}
	},

	apollo: {
		directory: {
			query: gql`
				{
					Directory {
						id
						WondeUsers {
							id
							base_type
							first_name
							last_name
							date_of_birth
							email
							status
							missing
							matched_id
							matched_name
							assign
							assigning
							selected
						}
					}
				}
			`,
			update: r => _.cloneDeep(r.Directory),
			result() {
				this.directoryLoading = false;
			}
		},
		matching: {
			query: gql`
				{
					Directory {
						id
						ThirdPartyUsers {
							id
							first_name
							last_name
							display_name
							search_name
							email
						}
					}
				}
			`,
			update: r => _.cloneDeep(r.Directory),
			result() {
				this.matchingLoading = false;
			}
		}
	},

	methods: {
		goToSync() {
			this.$router.push({ name: "directory.sync" });
		},
		async assignChange(row) {
			// Get the row we are assigning
			const assignRow = _.find(this.filtered, { assign: true });
			try {
				// Update row state (will be used for UI, post mutation query will refetch and therefore reset this)
				assignRow.assigning = true;
				// Close all the open assign select voxes
				_.each(this.filtered, r => {
					r.assign = false;
				});
				// Save the data
				await this.save([
					{
						idpId: assignRow.id,
						spId: row.id,
						action: "match"
					}
				]);
			} catch (error) {
				this.$message.error("Failed to assign user");
			}
		},

		async multiSelectCommand(action) {
			if (action === "passwords") {
				this.commandRunning = true;

				this.$confirm(
					"Passwords automatically assigned to users created via this app will be downloaded, but please note that any passwords changed by users will be incorrect.",
					{
						confirmButtonText: "OK",
						cancelButtonText: "Cancel",
						type: "warning"
					}
				).then(async () => {
					const passwords = await this.$apollo.query({
						query: gql`
							query DownloadPasswords($ids: [String!]!) {
								Passwords(ids: $ids) {
									first_name
									last_name
									username
									password
								}
							}
						`,
						variables: {
							ids: _.map(_.filter(this.filtered, { selected: true }), "id")
						},
						fetchPolicy: "network-only"
					});

					if (!passwords.data.Passwords.length) {
						this.$message.error("No passwords to download");
					} else {
						let data = [];
						data.push(["First name", "Last name", "User name", "Password"]);
						_.each(passwords.data.Passwords, r => {
							data.push([r.first_name, r.last_name, r.username, r.password]);
						});
						this.$message.success("File downloading");
						csv.exportToCsv("Credentials.csv", data);
					}
				});
			} else if (action === "remove") {
				try {
					await this.$confirm("Are you sure you want to delete these users? This action is irreversible!", {
						confirmButtonText: "Yes, I'm sure",
						cancelButtonText: "Cancel",
						type: "warning"
					});

					this.commandRunning = true;

					await this.save(
						_.map(_.filter(this.filtered, { selected: true }), user => {
							return {
								idpId: user.id,
								action
							};
						})
					);
				} catch (error) {
					this.$message.error(`Failed to perform ${action} on users.`);
				}
			} else {
				this.commandRunning = true;

				try {
					await this.save(
						_.map(_.filter(this.filtered, { selected: true }), user => {
							return {
								idpId: user.id,
								action
							};
						})
					);
				} catch (e) {
					this.$message.error(`Failed to perform ${action} on users.`);
				}
			}
			this.commandRunning = false;
		},

		assign(row) {
			// Make all the existing assign select boxes dissapear
			_.each(this.filtered, r => {
				r.assign = false;
			});
			// Set this one to show
			this.$set(row, "assign", true);
			// Focus it
			this.$nextTick(() => {
				this.$refs.assignSelect[0].focus();
			});
		},

		async save(rows) {
			this.matching = {};
			this.matchingLoading = true;
			this.saveLoading = true;

			await this.$apollo.mutate({
				mutation: gql`
					mutation UpdateDirectory($input: [DirectoryUpdateInput]!) {
						UpdateDirectory(input: $input) {
							id
							WondeUsers {
								id
								base_type
								first_name
								last_name
								email
								status
								matched_id
								matched_name
							}
						}
					}
				`,
				variables: {
					input: rows
				}
			});

			this.saveLoading = false;

			this.$apollo.queries.matching.refetch();

			return true;
		}
	},

	mounted() {
		this.$root.$on("directory-reload-required", () => {
			window.location.reload(true);
		});
	}
};
</script>